import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Router from 'vue-router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import store from './store'

import LangEn from './lang/en';
import LangJp from './lang/jp';
import LangChs from './lang/zhCHS';
import LangCht from './lang/zhCHT';

// elementUI 国际化
import enLocale from 'element-ui/lib/locale/lang/en'; //英文
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'; // 简体中文
import jaLocale from 'element-ui/lib/locale/lang/ja'; // 日文
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'; // 繁体中文
import locale from 'element-ui/lib/locale';

import 'element-ui/lib/theme-chalk/index.css'; // 默认主题

import Blob from './vendor/Blob.js';
import Export2Excel from './vendor/Export2Excel.js';

import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';

// import promise from 'es6-promise';
// promise.polyfill();

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import moment from 'moment'; // 日期处理
Vue.prototype.$moment = moment; // 赋值使用
moment.locale('zh-cn');// 需要汉化

import COMM from './common/common.js';
Vue.prototype.COMM = COMM;

Vue.prototype.$bus = new Vue()
import axios from 'axios';
import qs from 'qs';
import {baseUrl, baseImgPath} from '@/config/env'

Vue.prototype.qs = qs
//全局注册，使用方法为:this.qs
axios.defaults.withCredentials=true
Vue.prototype.$axios = axios
//全局注册，使用方法为:this.$axios
axios.defaults.baseURL = baseUrl; //baseUrl: 域名地址
Vue.prototype.basehtmlURL = baseUrl; //basehtmlURL: 设置加载html路径
Vue.prototype.baseImgPath = baseImgPath; //baseImgPath: 图片存放地址

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.use(ElementUI, {
    size: 'small'
});

const i18n = new VueI18n({	
    locale: 'jp',  
    messages: {
		'en'  : LangEn,
		'jp'  : LangJp,
		'chs' : LangChs,
		'cht' : LangCht,
		} ,
		silentTranslationWarn: true
})

let i18nResult = judgeLangCreateI18n(i18n);

Vue.prototype._i18n = i18nResult;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
	
	document.title = `PO+S PORTAL`;
	const userName =sessionStorage.getItem("UserCD");     // 获取登录邮箱账号
	
	
	if (to.path === '/forgetPwd') {
		next();
		return false;
	}
	// 路由不存在的话,404
	if (to.matched.length === 0 && store.getters.getHasRouter && (from.path !== '/login' && to.path !== '/home')) {
		next('/404');
		return;
	}
	if (to.path === '/login' ) { //去login的情况
		sessionStorage.clear();
		store.commit('setHasRouter', false);
		next();
		return;
	}
	
	if (to.path === '/' && from.path === '/') { //去login的情况
		next('/login');
		return; 
	} 
	
	if (!userName && to.path !== '/login' ){
		next('/login');
	}
	else{
	// 执行动态路由
	if (store.getters.getHasRouter) {
		// vuex中flag存在:动态路由存在不需要再次添加的情况
		if (from.path === '/login' && to.path === '/home') {
			// 第一从login出来情况
			if(router.resolve({name: 'Dashboard'}).route.matched.length !== 0){
				next('/dashboard');
			}
			return;
		} else {
			next();
			return;
		}
	}
	
	if (typeof(sessionStorage.getItem('ms_BAG')) !== 'undefined' && sessionStorage.getItem('ms_BAG') !== null &&
	typeof(sessionStorage.getItem('ms_SideBar')) !== 'undefined' && sessionStorage.getItem('ms_SideBar') !== null){
		// vuex中flag消失:页面刷新从sessionStorage中再去获取数据
		var ms_BAG = JSON.parse(sessionStorage.getItem('ms_BAG'));
		// 制作home的路由类型数据
		var childRoute = createRoutes(ms_BAG);
		var homeRoute = createHomeRoute(childRoute);
		// 添加动态路由
		router.addRoutes(homeRoute);
		// 再次设置vuex中flag
		store.commit('setHasRouter', true);
		next({...to, replace: false});
	} else {
		// 加载动态菜单和路由
		//网络请求接口
		var postUrl = 'BI/Base/GET_BAG_TreeListByUEMAIL';
		var web_suuid = sessionStorage.getItem('ms_username');
		
		axios.post(
				//请求的url
				postUrl,
				//请求参数
				{
				pMCBID: sessionStorage.getItem("UserCD"), //b0211f
				pMCCID: sessionStorage.getItem("CompanyCD"),  //会社ID
				pCOMLG: sessionStorage.getItem("COMLG"), //30126
				pLNGCT: sessionStorage.getItem("Language"), //语言
				pCOMNM: sessionStorage.getItem('CompanyName'),
				pMCCNM: sessionStorage.getItem('ShopName'),
				})
			.then((response) => {
				console.log(response)
				if (response.status === 200) {
					//请求成功
					// 制作home的路由类型数据
					var result = createRoutes(response.data);
					
					var homeRoute = createHomeRoute(result);
					// const newRouter = new Router(); // 创建一个新的、干净的路由
					// router.matcher = newRouter.matcher; // router就是真·路由啦，重点是这个macther
	
					// 动态添加路由
					router.addRoutes(homeRoute);
					// 设置vuex中的flag
					store.commit('setHasRouter', true);
					// sessionStorage存住数据
					sessionStorage.setItem('ms_BAG', JSON.stringify(response.data));
					
					var sidebarArr = createSidebar(response.data);
					sessionStorage.setItem('ms_SideBar', JSON.stringify(sidebarArr));
					
					// 查找用户的菜单权限标识集合
					 var postUrl = 'BI/Base/FINDPermissions';
					 //网络请求接口
					 axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: sessionStorage.getItem("UserCD"), //b0211f
							pMCCID: sessionStorage.getItem("CompanyCD"),  //会社ID
							pCOMLG: sessionStorage.getItem("COMLG"), //30126
							pLNGCT: sessionStorage.getItem("Language"), //语言
							pCOMNM: sessionStorage.getItem('CompanyName'),
							pMCCNM: sessionStorage.getItem('ShopName'),
						}
					 )
					 .then(res => {
					   // 保存用户权限标识集合
						sessionStorage.setItem('perms', JSON.stringify(res.data));
						next({...to, replace: false});
					})
				} else {
					next();
				}
			});
		}
	}
});



/**
 * @param {Array} bagArr 后台返回动态路由对象
 */
function createRoutes(bagArr) {
	// 路由
	var routeArr = [];
	bagArr.forEach((bag, index) => {
		if (typeof(bag.children) !== 'undefined' &&bag.children.length > 0) {
			bag.children.forEach((bagChild, ind) => {
				// 取出子路由设为同层路由
				var routeChildObj = createRouteDetail(bagChild);
				routeArr.push(routeChildObj);
			})
		}
		var routeObj = createRouteDetail(bag);
		routeArr.push(routeObj);
	})
	return routeArr;
}
// 具体制作路由方法
function createRouteDetail (bag) {
	var url = bag.url.split('/');
	// 从后台数据url中取得组件名
	var name = url[url.length - 1];
	var routeObj = null;
	// 制作Dashboard路由
	if (name === 'Dashboard') {
		// 制作首页路由
		var vueName = name + '.vue';
		var routeObj = {
			name: name,
			path: name.toLowerCase(),
			// 使用懒加载
			component: () => import(`@/pages/${vueName}`),
			meta: {
				title: bag.name,
				icon: bag.icon,
				index: name
			}
		}
	} else {
		// 制作普通菜单路由
		var vueName = bag.url + '.vue';
		var vueName = vueName.substr(1);
		var routeObj = {
			path: '/' + name.toLowerCase(),
			// 使用懒加载
			component: () => import(`@/pages/${vueName}`),
			meta: {
				title: bag.name,
				icon: bag.icon,
				index: name,
			},
			name: name
		}
	}
	return routeObj;
}


// 制作外层home路由
function createHomeRoute (routeArr) {
	// 制作Home路由
	var homeRoute = {
		path: '/',
		component: () => import( /* webpackChunkName: "home" */ './components/common/Home.vue'),
		meta: {
			title: 'Home'
		},
		// 添加子路由
		children: routeArr
	}
	return [homeRoute];
}

// 制作Sidebar
function createSidebar(bagArr) {
	// SideBar用
	var sideBarArr = [];
	var sideBarChildArr = [];
	var meta = null;
	bagArr.forEach((bag, index) => {
		if (bag.level !== 2) { // 排除用户中心和小铃铛特殊
			sideBarChildArr = [];
			var url = bag.url.split('/');
			// 从后台数据url中取得组件名
			var name = url[url.length - 1];
			if (typeof(bag.children) !== 'undefined' &&bag.children.length > 0) {
				//递归 去子层
				var result = createSidebar(bag.children);
				sideBarChildArr = result;
			}
			meta = {
				title: bag.name,
				icon: bag.icon,
				index: name
			};
			
			if(meta.index === '' || meta.index === null) { // 判断该siderbar是否存在路由
				meta.index = index.toString();
			}
			
			if(sideBarChildArr.length !== 0) {
				// 如果有子菜单则添加
				meta.subs = sideBarChildArr;
			}
			sideBarArr.push(meta);
		}
	});
	return sideBarArr;
}

function judgeLangCreateI18n(i18n) {
	if (typeof(sessionStorage.getItem('ms_lang')) !== 'undefined') {
		// 存过说明不是第一次进
		switch (sessionStorage.getItem('ms_lang')) {
			case '1': 		
				i18n.locale = 'chs'; //"简体中文"
				break;
			case '2':
				i18n.locale = 'cht'; //"繁体中文
				break;
			case '3':
				i18n.locale = 'en'; //"English"
				break;
			default:
				i18n.locale = 'jp'; //"日语"
				break;
		}
	}
	return i18n;
}

(function () {
	// 设置elementUI 默认语言
	switch (sessionStorage.getItem('ms_lang')) {
		case '1': 		
			locale.use(zhCNLocale); //"简体中文"
			break;
		case '2':
			locale.use(zhTWLocale); //"繁体中文
			break;
		case '3':
			locale.use(enLocale); //"English"
			break;
		default:
			locale.use(jaLocale); //"日语"
			break;
	}
})()

new Vue({
    router,
	store,
    i18n,
    render: h => h(App)
}).$mount('#app');
